// Bootstrap stub — generated by /bootstrap for Phase 1

import { AuthProvider } from "@/contexts/AuthContext";
import { AppRoutes } from "@/routes";

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;
